<template>
  <v-autocomplete
    v-model="localValue"
    :items="provinces"
    :label="$t('labels.provinceOrState')"
    :class="fieldClass"
    :disabled="disabled"
    :error-messages="errors"
  />
</template>

<script>
import { CustomFieldMixin } from '../mixins'

export default {
  name: 'ProvinceField',
  mixins: [CustomFieldMixin],
  props: {
    countryCode: String
  },
  computed: {
    provinces() {
      let regionCodes = this.regionCodes[this.countryCode] || []
      return regionCodes.map((value) => ({
        text: this.$t(`regions.${this.countryCode}.${value}`),
        value
      }))
    }
  },
  watch: {
    countryCode: function (v) {
      if (!this.regionCodes[v]) {
        this.localValue = null
      }
    }
  },
  data: () => ({
    regionCodes: {
      CA: ['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'],
      US: [
        'AL',
        'AK',
        'AS',
        'AZ',
        'AR',
        'CA',
        'CO',
        'CT',
        'DE',
        'DC',
        'FM',
        'FL',
        'GA',
        'GU',
        'HI',
        'ID',
        'IL',
        'IN',
        'IA',
        'KS',
        'KY',
        'LA',
        'ME',
        'MH',
        'MD',
        'MA',
        'MI',
        'MN',
        'MS',
        'MO',
        'MT',
        'NE',
        'NV',
        'NH',
        'NJ',
        'NM',
        'NY',
        'NC',
        'ND',
        'MP',
        'OH',
        'OK',
        'OR',
        'PW',
        'PA',
        'PR',
        'RI',
        'SC',
        'SD',
        'TN',
        'TX',
        'UT',
        'VT',
        'VI',
        'VA',
        'WA',
        'WV',
        'WI',
        'WY'
      ]
    }
  })
}
</script>
